import $ from 'jquery';
import AccountService from '../_shared/account-service';

/**
 * @desc Toggles appearance of ticket info on local (UK) version.
 */

export default class NotifyMe {
    /**
     * @param {string} buttonSelector
     */
    constructor(buttonSelector) {
        this.$buttons = $(buttonSelector);
        this.notifyLabelSelector = '.js-notify-label';
        this.notifiedLabelSelector = '.js-notified-label';
        this.localStorageKey = 'mc-fixture-notify-status-';

        this.init();
    }

    async init() {
        this.isInitialized = true;

        if (!this.$buttons.length) {
            this.isInitialized = false;
            return;
        }

        const isAuthenticated = await AccountService.isAuthenticated();

        if (!isAuthenticated) {
            this.updateButtonsLinkToLogin();
            this.showButtons();
        } else {
            this.userData = await AccountService.getUserData();
            this.checkNotifyMeStatus();
            this.attachEventListeners();
        }
    }

    updateButtonsLinkToLogin() {
        this.$buttons.each((i, button) => {
            $(button).attr('href', `/account/login?returnUrl=${document.location.href}`);
        });
    }

    /* eslint-disable class-methods-use-this */
    animateShowBtn($btn) {
        $btn.animate({ width: 'show' }, 300, 'swing', function () {
            $(this).css('display', 'flex');
        });
    }

    animateHideBtn($btn) {
        $btn.animate({ width: 'hide' }, 300);
    }
    /* eslint-enable class-methods-use-this */

    showButtons() {
        this.$buttons.each((i, button) => {
            this.animateShowBtn($(button).find(this.notifyLabelSelector));
            $(button).css('opacity', 1);
        });
    }

    checkNotifyMeStatus() {
        if (!this.userData) {
            this.localStorageData = new Set();
            this.showButtons();
            return;
        }

        try {
            const data = JSON.parse(window.localStorage.getItem(`${this.localStorageKey}${this.userData.id}`));
            this.localStorageData = new Set(data);
        } catch (e) {
            console.error('An error occurred while trying to parse fixture notify status');
            this.localStorageData = new Set();
        }

        if (!this.localStorageData.size) {
            this.showButtons();
            return;
        }

        this.$buttons.each((i, button) => {
            const dataUrl = $(button).data('buy-tickets-link');
            const buttonLabel = this.localStorageData.has(dataUrl)
                ? this.notifiedLabelSelector : this.notifyLabelSelector;
            $(button).css('opacity', 1);
            this.animateShowBtn($(button).find(buttonLabel));
        });
    }

    attachEventListeners() {
        this.$buttons.on('click', (event) => {
            event.preventDefault();
            if (this.userData) {
                const dataUrl = $(event.currentTarget).data('buy-tickets-link');
                this.saveStateToLocalStorage(dataUrl);
            }

            this.animateHideBtn($(event.currentTarget).find(this.notifyLabelSelector));
            this.animateShowBtn($(event.currentTarget).find(this.notifiedLabelSelector));
        });
    }

    saveStateToLocalStorage(url) {
        this.localStorageData.add(url);
        window.localStorage.setItem(`${this.localStorageKey}${this.userData.id}`, JSON.stringify([...this.localStorageData]));
    }
}
